import { cn } from "@monbits/ui";
import { Link, Outlet, useLocation } from "react-router-dom";

const TABS = [
	{ path: "/payments", label: "Payments", exact: true },
	{ path: "/payments/customers", label: "Customers" },
	{ path: "/payments/settings", label: "Settings" },
] as const;

export function PaymentsLayout() {
	const location = useLocation();

	return (
		<div className="space-y-6 p-4 sm:p-6">
			<h1 className="sr-only">Payments</h1>

			<div className="flex items-center gap-3">
				<span aria-hidden className="h-5 w-[3px] rounded-full bg-primary" />
				<p className="text-[11px] font-medium uppercase tracking-[0.2em] text-muted-foreground">
					Payments · Hosted checkout, customers, and settings
				</p>
			</div>

			<div className="flex items-center overflow-x-auto border-b">
				{TABS.map((tab) => {
					const isActive =
						"exact" in tab && tab.exact
							? location.pathname === tab.path
							: location.pathname.startsWith(tab.path);

					return (
						<Link
							key={tab.path}
							to={tab.path + location.search}
							className={cn(
								"flex-shrink-0 whitespace-nowrap px-4 py-2 text-sm font-medium transition-colors border-b-2 -mb-px",
								isActive
									? "border-primary text-foreground"
									: "border-transparent text-muted-foreground hover:text-foreground hover:border-muted-foreground",
							)}
						>
							{tab.label}
						</Link>
					);
				})}
			</div>

			<Outlet />
		</div>
	);
}
